module.exports = __webpack_public_path__ + "static/media/clouds.5bb9d7e1.png";